import { ChangeEnum } from "@/types/inventory";
import { SourceTypeEnum } from "@/types/common";
import { Product } from "@/types/product";
import { generateLotV2 } from "@/utils/codeParse";

export interface SaleInboundItemLike {
  id?: string;
  productId?: string;
  quantity?: number | null;
  bquantity?: number | null;
  product?: {
    id: string;
  } & Partial<Product> | null;
}

export interface InboundProductFromSaleItem extends Partial<Product> {
  id: string;
  code: string;
  quantity: number;
  maxQuantity: number;
  sourceId: string;
  sourceType: SourceTypeEnum.SALE_ITEM;
  lot?: string;
}

export const clampInboundQuantity = (value: number | null | undefined, maxQuantity?: number) => {
  const normalizedValue = value ?? 0;

  if (maxQuantity === undefined) return normalizedValue;

  return Math.min(normalizedValue, maxQuantity);
};

export const mergeInboundQuantities = (currentQuantity: number, addQuantity: number, maxQuantity?: number) => {
  return clampInboundQuantity(currentQuantity + addQuantity, maxQuantity);
};


export const getManulInboundStepIndexes = (flag: boolean) => {
  const offset = flag ? 1 : 0;

  return {
    saleOrder: flag ? 0 : -1,
    product: offset,
    location: offset + 1,
    preInventory: offset + 2,
    complete: offset + 3,
  };
};

export const buildInboundProductsFromSaleItems = (items: SaleInboundItemLike[]): InboundProductFromSaleItem[] => {
  // 生产入库下，销售订单只是商品来源；同商品在这里先合并成一行。
  const productMap = new Map<string, InboundProductFromSaleItem>();

  items.forEach(item => {
    const productId = item.product?.id || item.productId;
    const productCode = item.product?.code;
    let now = Date.now();

    if (!productId || !productCode) return;

    const quantity = Number(item.quantity || 0) + Number(item.bquantity || 0);
    const existing = productMap.get(productId);

    if (existing) {
      // 合并后的数量同时作为上限，供下一步编辑数量时限制使用。
      const nextQuantity = existing.quantity + quantity;
      productMap.set(productId, {
        ...existing,
        quantity: nextQuantity,
        maxQuantity: nextQuantity,
      });
      return;
    }

    productMap.set(productId, {
      ...(item.product || {}),
      id: productId,
      code: productCode,
      quantity,
      maxQuantity: quantity,
      sourceId: item.id || "",
      sourceType: SourceTypeEnum.SALE_ITEM,
      lot: generateLotV2(productCode, '', ++now)
    });
  });

  return Array.from(productMap.values());
};
